import Env from '../../base/env'
import Channels from '../../base/channels'
import WheelIndicator from 'wheel-indicator';
import Hammer from 'hammerjs'

export default class Emoji
{
    constructor(view)
    {
        // DOM
        this.view = view
        this.$content = this.view.querySelector('.gwrapper')
        this.$fillRevert = this.view.querySelector('.fill-revert')
        this.$tagline = this.view.querySelector('.tagline')
        this.$canvas = this.view.querySelector('.jsCanvas')
        // Vars
        this.viewport = Env.framework.toolbox.getViewport()
        // Pixi
        this.renderer = new PIXI.autoDetectRenderer({width : this.viewport.width  , height :this.viewport.height , transparent: true })
        this.stage = new PIXI.Container()
        this.container = new PIXI.Container(0xFFFFFF)
        this.ticker = new PIXI.ticker.Ticker()
        this.spriteEmoji = manifestImg.spriteContact
        this.spriteEmojiRevert = manifestImg.spriteRevertContact
        this.dMapSprite =  manifestImg.dMapContact
        this.shapeSize = this.viewport.height / 2
        // Flags
        this.SPEED = 5
        this.IS_REVERTED = false
        this.IS_ANIMATING = false
        // Fns
        this.funcResize = this.refresh.bind(this)
    }



    drawNoise()
    {
        // Sprite
        this.sprite = new PIXI.Sprite(new PIXI.Texture.fromImage( this.spriteEmoji ));
        this.sprite.anchor.set(0.5);
        this.sprite.width = this.shapeSize
        this.sprite.height = this.shapeSize
        this.sprite.position.x = this.renderer.width / 2
        this.sprite.position.y = this.renderer.height / 2
        this.sprite.alpha = 1
        // Sprite White
        this.spriteRevert = new PIXI.Sprite(new PIXI.Texture.fromImage( this.spriteEmojiRevert ));
        this.spriteRevert.anchor.set(0.5);
        this.spriteRevert.width = this.shapeSize
        this.spriteRevert.height = this.shapeSize
        this.spriteRevert.position.x = this.renderer.width / 2
        this.spriteRevert.position.y = this.renderer.height / 2
        this.spriteRevert.alpha = 0

        //Dmap
        this.displacementSprite = new PIXI.Sprite.fromImage( this.dMapSprite )
        this.displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
        this.displacementSprite.anchor.set(0.5);
        this.displacementSprite.x = 0
        this.displacementSprite.y = 0;
        this.displacementSprite.scale.x = 1
        this.displacementSprite.scale.y = 1
        this.displacementFilter = new PIXI.filters.DisplacementFilter( this.displacementSprite )
        this.displacementFilter.scale.x = 50;
        this.displacementFilter.scale.y = 10;
        this.displacementFilter.autoFit = false;
        this.stage.filters = [this.displacementFilter];

        // Circle
        this.circle = new PIXI.Graphics();
        this.circle.beginFill(0x000000);
        this.circle.arc(this.renderer.width / 2 ,this.renderer.height / 2 , this.shapeSize / 2 , 0 , 360)
        this.circle.cacheAsBitmap = true
        this.circle.alpha = 1
        // Circle Revert
        this.circleRevert = new PIXI.Graphics();
        this.circleRevert.beginFill(0xFFFFFF);
        this.circleRevert.arc(this.renderer.width / 2 ,this.renderer.height / 2 , this.shapeSize / 2 , 0 , 360)
        this.circleRevert.alpha = 0
        this.circleRevert.cacheAsBitmap = true
        TweenLite.set(this.circleRevert , { alpha : 0 }) // Force rendering
        // Noise
        this.filterNoise = new PIXI.filters.NoiseFilter(.6)
        this.filterNoise.padding = 10
        this.container.filters = [this.filterNoise];

        // Apply
        this.stage.addChild( this.displacementSprite );
        this.container.addChild(this.circle);
        this.container.addChild(this.circleRevert);
        this.stage.addChild(this.sprite);
        this.stage.addChild(this.spriteRevert);

    }

    destroy()
    {
        this.ticker.destroy()
        this.renderer.destroy()
        Channels.removeListener('window::smartresize', this.funcResize);
    }

    events()
    {
        Channels.on('window::smartresize',this.funcResize)

        this.indicator = new WheelIndicator({
            elem: this.view,
            callback: (e)=>{
                if(this.IS_ANIMATING === false) {
                    if(e.direction == 'down')
                    {
                        this.goToRevert()
                    }
                    else
                    {
                        this.goToNormal()
                    }
                }

            }
        });
        this.indicator.getOption('preventMouse');
    }

    goToRevert()
    {
        let timeline = new TimelineLite()

        if(this.IS_REVERTED === false ) {
            this.IS_ANIMATING = true
            Env.$html.classList.add('view--isReverted')
            timeline.add([
                TweenLite.fromTo(this.$content,.6 , { opacity : 1 } , { opacity : 0 , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.$tagline,.6 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeIn }),
                TweenLite.fromTo(this.$fillRevert, .6 , { y : '100%' } , { y : '0%' , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.sprite, .6 , { alpha : 1 } , { alpha : 0 , ease : Cubic.easeIn }),
                TweenLite.fromTo(this.circle, .6 , { alpha : 1 } , { alpha : 0 , ease : Cubic.easeIn }),
                TweenLite.fromTo(this.spriteRevert, .6 , { alpha : 0 } , { alpha : 1 , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.circleRevert, .6 , { alpha : 0 } , { alpha : 1 , ease : Cubic.easeOut }),
            ])
            timeline.add(()=>{
                this.IS_ANIMATING = false
                this.IS_REVERTED = true

            })
        }

    }

    goToNormal()
    {
        let timeline = new TimelineLite()

        if(this.IS_REVERTED === true) {
            this.IS_ANIMATING = true
            Env.$html.classList.remove('view--isReverted')
            timeline.add([
                TweenLite.fromTo(this.$content, .6 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.$tagline, .6 , { opacity : 1 } , { opacity : 0 , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.$fillRevert, .6 , { y : '0%' } , { y : '100%' , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.spriteRevert, .6 , { alpha : 1 } , { alpha : 0 , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.circleRevert, .6 , { alpha : 1 } , { alpha : 0 , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.sprite, .6 , { alpha : 0 } , { alpha : 1 , ease : Cubic.easeOut }),
                TweenLite.fromTo(this.circle, .6 , { alpha : 0 } , { alpha : 1 , ease : Cubic.easeOut }),
            ])
            timeline.add(()=>{
                this.IS_ANIMATING = false
                this.IS_REVERTED = false
            })
        }
    }

    refresh()
    {
        this.viewport = Env.framework.toolbox.getViewport()
        this.shapeSize = this.viewport.height / 2
        // Stage
        this.renderer.view.style.width = `${this.viewport.width}px`
        this.renderer.view.style.height = `${this.viewport.height}px`
        this.renderer.resize(this.viewport.width,this.viewport.height)
        // Image
        this.sprite.width = this.shapeSize
        this.sprite.height = this.shapeSize
        this.sprite.position.x = this.renderer.width / 2
        this.sprite.position.y = this.renderer.height / 2
        this.spriteRevert.width = this.shapeSize
        this.spriteRevert.height = this.shapeSize
        this.spriteRevert.position.x = this.renderer.width / 2
        this.spriteRevert.position.y = this.renderer.height / 2
        // Circle
        this.circle.clear();
        this.circle.cacheAsBitmap = false
        this.circle.beginFill(0x000000);
        this.circle.arc(this.renderer.width / 2 ,this.renderer.height / 2 , this.shapeSize / 2 , 0 , 360)
        this.circle.cacheAsBitmap = true
        this.circleRevert.clear();
        this.circleRevert.cacheAsBitmap = false
        this.circleRevert.beginFill(0xFFFFFF);
        this.circleRevert.arc(this.renderer.width / 2 ,this.renderer.height / 2 , this.shapeSize / 2 , 0 , 360)
        this.circleRevert.cacheAsBitmap = true
    }

    render()
    {
        let val = 0
        this.ticker.add((delta)=>{
            this.displacementSprite.x += 5 * (delta / this.SPEED);
            this.displacementSprite.y += 3 * (delta / this.SPEED);
            this.filterNoise.seed = Math.random() * delta
            this.renderer.render( this.stage );
        });
    }

    setup()
    {
        this.$canvas.appendChild( this.renderer.view );
        this.stage.addChild( this.container );
        this.drawNoise()
        this.events()
        this.render()
    }

    start()
    {
        this.ticker.start()
    }

    stop()
    {
        this.ticker.stop()
    }

}